import { AssetBasicDataProvider } from "../ui/asset_page_base"
import { AssetCategoryApi, FacilityApi, AssetAreaApi, AssetApi, AssetLoanApi } from "./api"

export class AssetMgtApi {

    assetCategoryApi = new AssetCategoryApi(this.baseUrl, this.options)
    facilityApi = new FacilityApi(this.baseUrl, this.options)
    assetAreaApi = new AssetAreaApi(this.baseUrl, this.options)
    assetBasicDataProvider = new AssetBasicDataProvider(this.assetCategoryApi, this.facilityApi, this.assetAreaApi, false)
    assetApi = new AssetApi(this.baseUrl, this.options)
    assetLoanApi = new AssetLoanApi(this.baseUrl, this.options)
    constructor(private baseUrl?: string, private options?: any) {
    }

}